import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"

export const TERMINATION_SHARED_REQUEST_FTE_TERMINATION = gql`
  mutation TerminationSharedRequestFteTermination(
    $engagementId: ID!
    $proposedDate: ISO8601Date!
    $reason: String!
  ) {
    requestTermination(
      input: { engagementId: $engagementId, proposedDate: $proposedDate, reason: $reason }
    ) {
      errors
    }
  }
`

const useRequestTermination = () => useMutation(TERMINATION_SHARED_REQUEST_FTE_TERMINATION)

export default useRequestTermination
